module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "small": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Everything in one place"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Make better decision, faster."])}
      },
      "fr": {
        "small": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout en un seul endroit"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De meilleures décisions, plus rapidement."])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"en":{"small":"Everything in one place","title":"Make better decision, faster."},"fr":{"small":"Tout en un seul endroit","title":"De meilleures décisions, plus rapidement."}}')
  delete Component.options._Ctor
  
}
